var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchQuery.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "用户姓名" } },
                        [
                          _c("j-input", {
                            attrs: { placeholder: "输入用户姓名模糊查询" },
                            model: {
                              value: _vm.queryParam.realname,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "realname", $$v)
                              },
                              expression: "queryParam.realname",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "手机号码" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入手机号码查询" },
                            model: {
                              value: _vm.queryParam.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "phone", $$v)
                              },
                              expression: "queryParam.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { md: 6, sm: 8 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset },
                          },
                          [_vm._v("\n              重置\n            ")]
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.handleToggleSearch },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.toggleSearchStatus ? "收起" : "展开"
                                ) +
                                "\n              "
                            ),
                            _c("a-icon", {
                              attrs: {
                                type: _vm.toggleSearchStatus ? "up" : "down",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator", staticStyle: { "border-top": "5px" } },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("添加用户")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function ($event) {
                  return _vm.handleExportXls("用户信息")
                },
              },
            },
            [_vm._v("导出")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-right": "10px" },
              attrs: { type: "primary", icon: "import" },
              on: { click: _vm.openImportModal },
            },
            [_vm._v("\n      导入\n    ")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "hdd" },
              on: {
                click: function ($event) {
                  _vm.recycleBinVisible = true
                },
              },
            },
            [_vm._v("回收站")]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    {
                      attrs: { slot: "overlay" },
                      on: { click: _vm.handleMenuClick },
                      slot: "overlay",
                    },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1" },
                        [
                          _c("a-icon", {
                            attrs: { type: "delete" },
                            on: { click: _vm.batchDel },
                          }),
                          _vm._v("\n          删除\n        "),
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        { key: "2" },
                        [
                          _c("a-icon", {
                            attrs: { type: "lock" },
                            on: {
                              click: function ($event) {
                                return _vm.batchFrozen("2")
                              },
                            },
                          }),
                          _vm._v("\n          冻结\n        "),
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        { key: "3" },
                        [
                          _c("a-icon", {
                            attrs: { type: "unlock" },
                            on: {
                              click: function ($event) {
                                return _vm.batchFrozen("1")
                              },
                            },
                          }),
                          _vm._v("\n          解冻\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "8px" } },
                    [
                      _vm._v("\n        批量操作\n        "),
                      _c("a-icon", { attrs: { type: "down" } }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("j-super-query", {
            attrs: { fieldList: _vm.superQueryFieldList },
            on: { handleSuperQuery: _vm.handleSuperQuery },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" },
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon",
              }),
              _vm._v("\n      已选择 \n      "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length)),
              ]),
              _vm._v("\n      项  \n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected },
                },
                [_vm._v("清空")]
              ),
            ]
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
              },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "avatarslot",
                fn: function (text, record, index) {
                  return [
                    _c(
                      "div",
                      { staticClass: "anty-img-wrap" },
                      [
                        _c("a-avatar", {
                          attrs: {
                            shape: "square",
                            src: _vm.getAvatarView(record.avatar),
                            icon: "user",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(record)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v("\n            更多\n            "),
                              _c("a-icon", { attrs: { type: "down" } }),
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDetail(record)
                                      },
                                    },
                                  },
                                  [_vm._v("详情")]
                                ),
                              ]),
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleChangePassword(
                                          record.username
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("密码")]
                                ),
                              ]),
                              _c(
                                "a-menu-item",
                                [
                                  _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定删除吗?" },
                                      on: {
                                        confirm: () =>
                                          _vm.handleDelete(record.id),
                                      },
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  ),
                                ],
                                1
                              ),
                              record.status == 1
                                ? _c(
                                    "a-menu-item",
                                    [
                                      _c(
                                        "a-popconfirm",
                                        {
                                          attrs: { title: "确定冻结吗?" },
                                          on: {
                                            confirm: () =>
                                              _vm.handleFrozen(
                                                record.id,
                                                2,
                                                record.username
                                              ),
                                          },
                                        },
                                        [_c("a", [_vm._v("冻结")])]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              record.status == 2
                                ? _c(
                                    "a-menu-item",
                                    [
                                      _c(
                                        "a-popconfirm",
                                        {
                                          attrs: { title: "确定解冻吗?" },
                                          on: {
                                            confirm: () =>
                                              _vm.handleFrozen(
                                                record.id,
                                                1,
                                                record.username
                                              ),
                                          },
                                        },
                                        [_c("a", [_vm._v("解冻")])]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("a-menu-item", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAgentSettings(
                                          record.username
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("代理人")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("user-modal", { ref: "modalForm", on: { ok: _vm.modalFormOk } }),
      _c("password-modal", {
        ref: "passwordmodal",
        on: { ok: _vm.passwordModalOk },
      }),
      _c("sys-user-agent-modal", { ref: "sysUserAgentModal" }),
      _c("user-recycle-bin-modal", {
        attrs: { visible: _vm.recycleBinVisible },
        on: {
          "update:visible": function ($event) {
            _vm.recycleBinVisible = $event
          },
          ok: _vm.modalFormOk,
        },
      }),
      _c("ImportUserInfo", { ref: "importUserInfo" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }